export const BLOG_SOCIAL_BUTTON = 'post-page__social-link';
export const WINDOW_HEIGHT = 500;
export const WINDOW_WIDTH = 500;
